export const formatCreateKb = (json) => {
  return {
    kbid: json.kbid,
    kb_updated: json.kbud,
    short_name: json.sn,
    status: json.sts
  }
}

